export default __webpack_public_path__ + "static/media/logo192.1e70b452.png";